import "../../styles/main.scss";

import { MDCTextField } from "@material/textfield";
import { MDCDialog } from "@material/dialog";
import { MDCTooltip, YPosition } from '@material/tooltip';

const nodeTooltipLoginIdentity = document.querySelector('#tooltip-login-identity');
if (nodeTooltipLoginIdentity) {
    const tooltipLoginIdentity = new MDCTooltip(nodeTooltipLoginIdentity);
    tooltipLoginIdentity.setTooltipPosition({
        yPos: YPosition.ABOVE,
    });
}

const textFields = [].map.call(
  document.querySelectorAll(".mdc-text-field"),
  function (el) {
    return new MDCTextField(el);
  }
);

const successDialogContainer = document.querySelector(
  ".password-change-success-dialog"
);
if (successDialogContainer) {
  const sDialog = new MDCDialog(successDialogContainer);
  sDialog.open();
}

// trigger open button modal for password rule
const passwordRuleDialogContainer = document.querySelector(
  ".password-rule-dialog"
);

const btnOpenDialogPassword = document.getElementById("open-password-dialog");
if (passwordRuleDialogContainer !== null) {
  const passwordDialog = new MDCDialog(passwordRuleDialogContainer);
  if (btnOpenDialogPassword) {
    btnOpenDialogPassword.onclick = function () {
      passwordDialog.open();
    };
  }

  const btnCloseDialogPassword = document.getElementById(
    "btn-close-password-dialog"
  );
  if (btnCloseDialogPassword) {
    btnCloseDialogPassword.onclick = function () {
      passwordDialog.close();
    };
  }
}
